export interface AppTheme{
  name: string,
  schema: AppThemeSchema,
}



export interface AppThemeSchema{
  logoHeight: string,
  logoUrl: string,
  backgroundImgUrl: string,
  siteName: string,
  shortSiteName?: string,
  languageFolder?: string,
  
  bodyBackgroundColor: string,
  faviconUrl?: string,

  fontPrimary: string,
  fontSecondary: string,

  textRoomTypeColor?: string, //empty use text default color
  cardRoomTypeColor?: string, //empty use cardBody color
  cardBodyColor: string,
  cardBorderRadius: string,
  cardMobileBorderRadius?: string, //empty use cardBorderRadius

  successColor: string,
  dangerColor: string,
  warningColor: string,
  mutedColor: string,

  headlineColor?: string, //Empty Use default color
  headlineFont?: string, //Empty use default font

  primaryColor: string,
  primaryDarkColor: string,
  secondaryColor: string,

  headerBackgroundColor: string,
  headerTextColor: string,
  headerHeight: string,
  headerTextSize: string,
  
  footerBackgroundColor?: string, //empty use secondary color
  footerTextColor?: string, //empty use tertiary color

  sideMenuBackgroundColor: string,
  sideMenuTextColor?: string, //default text


  buttonPrimaryTextColor: string,
  buttonPrimaryHoverColor?: string, //empty use primary dark
  buttonSecondaryTextColor?: string, //empty use teriary color
  buttonDisabledColor: string,
  buttonRadius: string,


  textDefaultColor: string,
  textDefaultMediumColor: string,
  textDefaultLightColor: string,
  textPrimaryColor: string,
  textSecondaryColor: string,
  textTertiaryColor: string,

  borderColor: string,
  borderActiveColor: string,
  borderRadius?: string //default 4px

  formLabelColor: string,
  formPlaceHolderColor: string,
  formBorderRadius?: string, //empty use borderRadius
  formBorderWidth?: string,
  formControlBackgroundColor?: string, //empty use white
  formInputColor?: string,

  tableHeaderColor: string,

  separateProfileContactDetailFormToTwoSections?: boolean,
  useExpandedFooter?: boolean,
  useSearchIconFont?: boolean
}

export interface ReadRemoteThemeRS {
  themes: AppTheme[],
  defaultTheme: string,
}

export const MapAppThemeVariable = {
  logoUrl: '--logo-url',
  logoHeight: '--logo-height',
  backgroundImgUrl: '--background-img-url',
  faviconUrl: '--favicon-url', 

  bodyBackgroundColor: '--body-background-color',
  fontPrimary: '--font-primary',
  fontSecondary: '--font-secondary',

  textRoomTypeColor: '--text-room-type-color',
  cardRoomTypeColor: '--card-room-type-color',
  cardBodyColor: '--card-body-color',
  cardBorderRadius: '--card-border-radius',
  cardMobileBorderRadius: '--card-mobile-border-radius',

  successColor: '--success-color',
  dangerColor: '--danger-color',
  warningColor: '--warning-color',
  mutedColor: '--muted-color',

  headlineColor: '--headline-color', 
  headlineFont: '--headline-font', 

  primaryColor: '--primary-color',
  primaryDarkColor: '--primary-dark-color',
  secondaryColor: '--secondary-color',

  headerBackgroundColor: '--header-background-color',
  headerTextColor: '--header-text-color',
  headerHeight: '--header-height',
  headerTextSize: '--header-text-size',
  
  footerBackgroundColor: '--footer-background-color',
  footerTextColor: '--footer-text-color',

  sideMenuBackgroundColor: '--side-menu-background-color',
  sideMenuTextColor: '--side-menu-text-color', 


  buttonPrimaryTextColor: '--button-primary-text-color',
  buttonPrimaryHoverColor: '--button-primary-hover-color',
  buttonSecondaryTextColor: '--button-secondary-text-color',
  buttonDisabledColor: '--button-disabled-color',
  buttonRadius: '--button-radius',


  textDefaultColor: '--text-default-color',
  textDefaultMediumColor: '--text-default-medium-color',
  textDefaultLightColor: '--text-default-light-color',
  textPrimaryColor: '--text-primary-color',
  textSecondaryColor: '--text-secondary-color',
  textTertiaryColor: '--text-tertiary-color',

  borderColor: '--border-color',
  borderActiveColor: '--border-active-color',
  borderRadius: '--border-radius', 

  formLabelColor: '--form-label-color',
  formPlaceHolderColor: '--form-placeholder-color',
  formBorderRadius: '--form-border-radius',
  formBorderWidth: '--form-border-width',
  formControlBackgroundColor: '--form-control-background-color',
  formInputColor: '--form-input-color',

  tableHeaderColor: '--table-header-color',
}

interface FontFamilyOption {
  name: string,
  code: string,
  linkImport?: string,
}

export const FONT_FAMILY_OPTION: FontFamilyOption[] = [
  {
    name: 'Inter',
    code: 'Inter',
  },
  {
    name: 'Tahoma',
    code: 'Tahoma',
  },
  {
    name: 'Trebuchet MS',
    code: 'Trebuchet MS',
  },
  {
    name: 'Times New Roman',
    code: 'Times New Roman'
  },
  {
    name: 'Garamond',
    code: 'Garamond'
  },
  {
    name: 'Sour Gummy',
    code: 'Sour Gummy',
    linkImport: 'https://fonts.googleapis.com/css2?family=Sour+Gummy:ital,wght@0,100..900;1,100..900&display=swap'
  },
  {
    name: 'Doto',
    code: 'Doto',
    linkImport: 'https://fonts.googleapis.com/css2?family=Doto:wght@100..900&display=swap" rel="stylesheet',
  },
  {
    name: 'Dancing Script',
    code: 'Dancing Script',
    linkImport: 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap" rel="stylesheet'
  },
  {
    name: 'Monoton',
    code: 'Monoton',
    linkImport: 'https://fonts.googleapis.com/css2?family=Monoton&display=swap'
  },
  {
    name: 'Dosis',
    code: 'Dosis',
    linkImport: 'https://fonts.googleapis.com/css2?family=Dosis&display=swap'
  },
  {
    name: 'Open Sans',
    code: 'Open Sans',
  },
  {
    name: 'DM Sans',
    code: 'DM Sans',
    linkImport: 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap'
  }
]